<automata-closing-side-drawer [title]="title" [preventClose]="preventClose">
  <automata-side-drawer-content>
    <div class="running-disclaimer" *ngIf="(isEditable$ | async) === false">
      <glxy-alert type="warning">
        {{ editingPreventedWarning() | async }}
      </glxy-alert>
    </div>
    <div>
      <div class="content">
        <ng-container *ngIf="triggerEditorControl?.isEditing && (isAvailableOnSubscriptionLevel$ | async) === false">
          <div class="step-name">{{ name | translate }}</div>
          <div class="upgrade-title">{{ upgradeTitle | translate }}</div>
          <div class="upgrade-description">
            {{ upgradeDescription | translate }}
          </div>
          <button mat-flat-button color="primary" (click)="upgrade()">
            {{ 'COMMON.ACTION_LABELS.UPGRADE' | translate }}
          </button>
        </ng-container>
        <div [hidden]="triggerEditorControl?.isEditing && (isAvailableOnSubscriptionLevel$ | async) === false">
          <div class="app-requirements-alert" *ngIf="automationContext === context.AUTOMATION_CONTEXT_SMB">
            <automata-app-requirements-alert [requiredApps]="(taskDefinition$ | async)?.requiredApps">
            </automata-app-requirements-alert>
          </div>

          <span class="start-when">
            <strong>
              {{ 'AUTOMATIONS.EDITOR.TRIGGERS.START_WHEN' | translate }}
            </strong>
          </span>
          <automata-trigger-editor-control
            #triggerEditorControl
            [automation]="automation"
            [taskDefinitionId]="taskDefinitionId"
            [step]="automation.triggerStep"
            [triggerChoices]="triggerChoices"
            [isWaitingForEvent]="false"
            (selectNewTrigger)="selectedNewTrigger($event)"
            (controlCreated)="subscribeToLoadingEvents($event, filterPanel)"
          ></automata-trigger-editor-control>
          <div>
            <div *ngIf="supportsCustomOutputParameters && triggerEditorControl.isEditing">
              <automata-custom-output-parameters
                [step]="automation.triggerStep"
                [descriptionText]="'AUTOMATIONS.EDITOR.RETURN_VALUES.RETURN_VALUES_TRIGGER_DESCRIPTION'"
                [sectionTitleText]="'AUTOMATIONS.EDITOR.RETURN_VALUES.RETURN_VALUES'"
              ></automata-custom-output-parameters>
            </div>
          </div>

          <!-- Note: The component needs to be hidden (not ngIf'd) as clearing and re-validating the filter choices is asynchronous. -->
          <automata-filter-panel
            #filterPanel
            [triggerFilters]="triggerFilters"
            [automation]="automation"
            [class.hidden]="!triggerEditorControl.isEditing"
            (controlCreated)="subscribeToLoadingEvents(triggerEditorControl, $event)"
          ></automata-filter-panel>
          <ng-container *ngIf="triggerEditorControl?.isEditing">
            <div class="divider-padding">
              <mat-divider></mat-divider>
            </div>
            <glxy-form-field>
              <glxy-label>{{ 'AUTOMATIONS.EDITOR.NOTES' | translate }}</glxy-label>
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="4"
                cdkAutosizeMaxRows="8"
                [formControl]="stepNotesControl"
              ></textarea>
            </glxy-form-field>
          </ng-container>
        </div>
      </div>
    </div>
  </automata-side-drawer-content>

  <!-- Hide the footer if the automation is running or if it's not possible to save nor go back. -->
  <automata-side-drawer-footer
    *ngIf="
      (isEditable$ | async) &&
      !!triggerEditorControl.taskDefinitionId &&
      (isAvailableOnSubscriptionLevel$ | async) === true
    "
  >
    <div class="footer-actions">
      <!-- Hide the save button if the user is selecting a trigger. Disable if things are loading. -->
      <ng-container *ngIf="!isProcessing; else processing">
        <button
          mat-flat-button
          color="primary"
          [disabled]="isLoading"
          [class.invisible]="!triggerEditorControl.taskDefinitionId"
          (click)="save()"
        >
          {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
        </button>
      </ng-container>
      <ng-template #processing>
        <button mat-flat-button color="primary" class="processing-message">
          <span>
            <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
          </span>
        </button>
      </ng-template>
    </div>
  </automata-side-drawer-footer>
</automata-closing-side-drawer>
